import BtnToProduct from "./BtnToProduct";

const Card = ({decoders, card}) => {
    return <div className='packages-tariff-card'>
        <div>
          <span className='card-pointed'>{card?.name}</span>
          <ul>
            {card?.programs && card?.programs.map(li => 
              <li>
                {/* Setanta Sports 1 (Eng, Geo, Ukr, Rus) */}
                {li}
              </li>  
            )}
          </ul>
        </div>
        <BtnToProduct decoders={decoders}/>
    </div>
}

export default Card;